<div class="scoreDetail__cont" *ngIf="hasScore">
  <ng-container *ngIf="withBorder">
    <div class="scoreDetail__divider">
      <app-ds-divider [orientation]="dividerOrientation"></app-ds-divider>
    </div>
  </ng-container>
  <div class="scoreDetail__tag">
    <app-ds-tag-rating
      [size]="tagRatingSize"
      [type]="tagRatingType"
      [value]="score"
      [title]="legendByScore | transloco">
    </app-ds-tag-rating>
  </div>
</div>